import { ScorecardSection } from './ai-scorecard-statistic.model';

export interface SectionDisplayData {
  title: string;
  agentName: string;
  firstScore: number;
  bestScore: number;
  avgScore: number;
  improvement: number;
  performanceImprovement: number;
  consistencyGap: number;
  criteriaList: CriteriaDisplayData[];
}

export interface CriteriaDisplayData {
  title: string;
  firstAttempt: number;
  bestAttempt: number;
  avgScore: number;
  improvement: number;
  performanceImprovement: number;
  consistencyGap: number;
}

export class ScorecardSectionProcessor implements SectionDisplayData {
  public title: string;
  public agentName: string;
  public firstScore: number;
  public bestScore: number;
  public avgScore: number;
  public improvement: number;
  public performanceImprovement: number;
  public consistencyGap: number;
  public criteriaList: CriteriaDisplayData[];

  constructor(section: ScorecardSection) {
    this.title = section.sectionTitle;
    this.agentName = section.agentFirstName;
    this.criteriaList = this.processCriteria(section);

    this.firstScore = section.firstAttemptScore || 0;
    this.bestScore = section.bestAttemptScore || 0;
    this.avgScore =  section.totalAttempts ? section.totalScore / section.totalAttempts : 0;
    this.improvement = this.avgScore - this.firstScore;
    this.performanceImprovement = this.bestScore - this.firstScore;
    this.consistencyGap = this.bestScore - this.avgScore;
  }

  private processCriteria(section: ScorecardSection): CriteriaDisplayData[] {
    return section.criterias.map(c => {
      const avgScore = c.totalAttempts ? c.totalScore / c.totalAttempts : 0;
      return {
        title: c.criteriaTitle,
        firstAttempt: c.firstAttemptScore || 0,
        bestAttempt: c.bestAttemptScore || 0,
        avgScore,
        improvement: avgScore - c.firstAttemptScore,
        performanceImprovement: c.bestAttemptScore - c.firstAttemptScore,
        consistencyGap: c.bestAttemptScore - avgScore
      };
    });
  }
}

